import Skeleton from "react-loading-skeleton";
import { RazorpayPaymentButton } from "./RazorpayPayment";
import { StripePaymentButton } from "./StripePayment";
import { PaypalPaymentButton } from "./PaypalPayment";

export const PaymentDetailsRight = ({
  loadingPlans,
  isCouponApplied,
  plans,
  estimatedData,
  appliedCoupon,
  coupon,
  couponSuccess,
  handleApply,
  handleRemove,
  setCoupon,
  loading,
  isPaymentProcessing = false,
  processingGateway = null,
  subscribeToPlanPaypal,
  subscribeToPlanRazorPay,
  subscribeToPlanStripe,
  error,
}) => {
  return (
    <>
      <div className="col-md-5 ">
        <div className="d-none d-md-flex mb-4 justify-content-center align-items-center">
          {loadingPlans ? (
            <Skeleton height={60} width={100} />
          ) : (
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogo.png"
              alt="img"
            />
          )}
        </div>

        <div
          className="p-4 border border-info h-100"
          style={{
            backgroundColor: "rgba(135, 206, 250, 0.1)",
            borderRadius: "20px",
            paddingTop: "40px",
            paddingBottom: "40px"
            
          }}
        >
          <h6 className="text-center">
            {" "}
            {loadingPlans ? (
              <Skeleton width={100} />
            ) : isCouponApplied ? (
              "Sub Total"
            ) : (
              "Total price"
            )}
          </h6>
          {isCouponApplied && (
            <>
              {" "}
              <h2 className="text-center fw-semibold fs-4">
                {" "}
                {plans?.plans?.[0]?.currency === "USD" ? "$" : "₹"}
                {Number(estimatedData?.original_amount).toFixed(2)}
              </h2>
              <h6 className="text-center fw-semibold ">
                After {Number(estimatedData?.coupon?.discount_percent)} % coupon
                discount
              </h6>
            </>
          )}
          <h2 className="text-center fw-semibold fs-1">
            {loadingPlans ? (
              <Skeleton width={120} height={40} />
            ) : (
              <>
                {estimatedData?.trial_eligibility ? (
                  <>
                    {plans?.plans?.[0]?.currency === "USD" ? "$" : "₹"}0
                  </>
                ) : (
                      <> {plans?.plans?.[0]?.currency === "USD" ? "$" : "₹"}{Number(estimatedData?.final_amount).toFixed(2)}</>
                )}
                {estimatedData?.trial_eligibility && (
                  <p style={{ fontSize: "12px" ,fontWeight:"300"}}>
                    {" "}
                    Enjoy {plans?.plans?.[0]?.trial_days} trial days, after
                    which Yuva Quest will charge{" "}
                    {plans?.plans?.[0]?.currency === "USD" ? "$" : "₹"}
                    {Number(estimatedData?.final_amount).toFixed(2)} per year.
                  </p>
                )}
              </>
            )}
          </h2>
          {!estimatedData?.trial_eligibility ? (
            <p className="text-center text-muted">
              {loadingPlans ? <Skeleton width={80} /> : "Billed Annually"}
            </p>
          ) : null}

          {plans?.plans?.[0]?.currency === "USD" ? (
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter coupon code"
                value={appliedCoupon ?? coupon}
                readOnly={!!appliedCoupon}
                onChange={(e) => setCoupon(e.target.value)}
              />
              {!appliedCoupon ? (
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={handleApply}
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>
              ) : (
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={handleRemove}
                >
                  Remove
                </button>
              )}
            </div>
          ) : null}

          {error && <div className="text-danger">{error}</div>}
          {couponSuccess && <div className="text-success">{couponSuccess}</div>}
          <div className="d-grid gap-2">
            {loadingPlans ? (
              <>
                <Skeleton height={45} />
                <Skeleton width={30} className="mx-auto" />
                <Skeleton height={45} />
              </>
            ) : plans?.plans?.[0]?.currency === "USD" ? (
              <>
                <StripePaymentButton
                  subscribeToPlanStripe={subscribeToPlanStripe}
                  loading={processingGateway === "stripe"}
                  disabled={Boolean(processingGateway || isPaymentProcessing)}
                />
                <small className="text-center">or</small>
                <PaypalPaymentButton
                  subscribeToPlanPaypal={subscribeToPlanPaypal}
                  loading={processingGateway === "paypal"}
                  disabled={Boolean(processingGateway || isPaymentProcessing)}
                />
              </>
            ) : plans?.plans?.[0]?.currency === "INR" ? (
              <>
                {/* <StripePaymentButton
                  subscribeToPlanStripe={subscribeToPlanStripe}
                />
                <small className="text-center ">or</small> */}
                <RazorpayPaymentButton
                  subscribeToPlanRazorPay={subscribeToPlanRazorPay}
                  estimatedData={estimatedData}
                  loading={processingGateway === "razorpay" || (isPaymentProcessing && !processingGateway)}
                  disabled={Boolean(processingGateway || isPaymentProcessing)}
                />
              </>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
